<h1 mat-dialog-title>
  {{ (data.title ? data.title : 'Upload Project Logo or Picture') | transloco }}
</h1>

<div mat-dialog-content>
  <div
    *ngIf="!imageChangedEvent.target?.files.length"
    (click)="fileAttached.click()"
    (dragleave)="onDragLeave($event)"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    [class.dragging]="isDragging"
    class="upload-file-input mb-3 drop-zone"
  >
    <div class="flex flex-col justify-center items-center gap2">
      <mat-icon class="icon-size-7" svgIcon="mat_outline:file_upload"></mat-icon>
      <p class="text-secondary mt-2 text-center mb-0">
        {{ 'Drag and drop files here to attach,' | transloco }}<br />
        {{ 'or click to browse files.' | transloco }}
      </p>
    </div>

    <input
      [accept]="this.data.acceptPdf ? 'image/*,.pdf' : 'image/*'"
      type="file"
      class="hidden"
      #fileAttached
      (change)="fileChangeEvent($event)"
      [id]="data?.type !== 'projectLogo' ? 'uploadLogo' + data.type : 'uploadInput'"
    />
  </div>

  <image-cropper
    *ngIf="imageChangedEvent.target?.files.length"
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="!data?.freeAspectRatio"
    [aspectRatio]="3 / 2"
    format="png"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded()"
    (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"
  >
  </image-cropper>

  <!--  <img [src]="croppedImage" />-->
</div>
<div mat-dialog-actions class="flx-row justify-end">
  <button (click)="onNoClick()" id="close" mat-button>{{ 'Cancel' | transloco }}</button>
  <button
    mat-flat-button
    id="continue"
    color="primary"
    [disabled]="!croppedImage"
    [mat-dialog-close]="croppedImage"
    cdkFocusInitial
  >
    {{ 'Upload' | transloco }}
  </button>
</div>
